<div class="loading-overlay" *ngIf="isLoading">
  <div class="loader-container">
    <div class="loader-spinner"></div>
    <p class="loader-text">Chargement en cours...</p>
  </div>
</div>

<div class="services-page-container">
  <div class="services-content-wrapper">
    <div class="services-table-container">
      <div class="px-6 py-4 border-b border-gray-200 flex items-center gap-4 relative">
        <div class="search-container-fixed flex-1 flex items-center justify-center gap-3">
          <div class="relative w-full max-w-xs">
            <span class="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 material-symbols-outlined text-sm pointer-events-none">search</span>
            <input
              type="text"
              class="search-input-services w-full pl-9 pr-3 py-1.5 text-sm border border-gray-300 rounded-lg focus:border-blue-500 focus:outline-none"
              [(ngModel)]="searchTerm"
              (input)="applyFilter()"
              placeholder="Rechercher par plateforme ou service..."
            />
          </div>
          <span class="inline-flex items-center px-3 py-1 rounded-full text-sm font-medium bg-gray-100 text-gray-700 whitespace-nowrap">
            {{ filtered.length }} service{{ filtered.length > 1 ? 's' : '' }}
            <span *ngIf="totalPages > 1" class="ml-2 text-xs text-gray-500">
              (Page {{ currentPage }}/{{ totalPages }})
            </span>
          </span>
        </div>
        
        <div class="flex-shrink-0">
          <select 
            [(ngModel)]="selectedPlatform"
            (change)="onPlatformChange()"
            class="services-platform-select px-4 py-2 border border-gray-300 rounded-lg focus:border-blue-500 focus:outline-none text-sm bg-white cursor-pointer">
            <option value="">Toutes les plateformes</option>
            <option *ngFor="let platform of platforms" [value]="platform">{{ platform }}</option>
          </select>
        </div>
      </div>

      <div class="px-6 py-4 border-b border-gray-200 flex items-center gap-4">
        <label class="inline-flex items-center cursor-pointer">
          <input
            type="checkbox"
            class="w-4 h-4 text-blue-600 border-gray-300 rounded focus:ring-blue-500 cursor-pointer"
            [checked]="selectAll"
            (change)="toggleSelectAll()"
          />
          <span class="ml-2 text-sm font-medium text-gray-700">
            Tout sélectionner ({{ selectedServices.size }})
          </span>
        </label>

        <button
          (click)="openBulkEditModal()"
          [disabled]="selectedServices.size === 0"
          class="px-4 py-2 bg-blue-600 text-white rounded-lg text-sm font-medium hover:bg-blue-700 transition-all flex items-center gap-2 disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:bg-blue-600">
          <span class="material-symbols-outlined text-sm">edit</span>
          Changer en masse
        </button>
      </div>

      <div class="overflow-x-auto">
        <table class="services-table">
          <thead class="services-table-header">
            <tr>
              <th class="min-w-[50px] text-center">
                <input
                  type="checkbox"
                  class="w-4 h-4 text-blue-600 border-gray-300 rounded focus:ring-blue-500 cursor-pointer"
                  [checked]="selectAll"
                  (change)="toggleSelectAll()"
                />
              </th>
              <th class="cursor-pointer hover:bg-gray-50 transition-colors min-w-[150px] text-center" (click)="toggleSort('platform')">
                <div class="flex items-center justify-center gap-2">
                  <span>Plateforme</span>
                  <span class="sort-icon text-xs" [ngClass]="sortField === 'platform' ? (sortDirection === 'asc' ? 'asc' : 'desc') : ''">
                    <span *ngIf="sortField !== 'platform'">↕</span>
                    <span *ngIf="sortField === 'platform' && sortDirection === 'asc'">↓</span>
                    <span *ngIf="sortField === 'platform' && sortDirection === 'desc'">↑</span>
                  </span>
                </div>
              </th>
              <th class="cursor-pointer hover:bg-gray-50 transition-colors min-w-[200px] text-center" (click)="toggleSort('service')">
                <div class="flex items-center justify-center gap-2">
                  <span>Service</span>
                  <span class="sort-icon text-xs" [ngClass]="sortField === 'service' ? (sortDirection === 'asc' ? 'asc' : 'desc') : ''">
                    <span *ngIf="sortField !== 'service'">↕</span>
                    <span *ngIf="sortField === 'service' && sortDirection === 'asc'">↓</span>
                    <span *ngIf="sortField === 'service' && sortDirection === 'desc'">↑</span>
                  </span>
                </div>
              </th>
              <th class="cursor-pointer hover:bg-gray-50 transition-colors min-w-[120px] text-center" (click)="toggleSort('totalFree')">
                <div class="flex items-center justify-center gap-2">
                  <span>Quantité</span>
                  <span class="sort-icon text-xs" [ngClass]="sortField === 'totalFree' ? (sortDirection === 'asc' ? 'asc' : 'desc') : ''">
                    <span *ngIf="sortField !== 'totalFree'">↕</span>
                    <span *ngIf="sortField === 'totalFree' && sortDirection === 'asc'">↓</span>
                    <span *ngIf="sortField === 'totalFree' && sortDirection === 'desc'">↑</span>
                  </span>
                </div>
              </th>
              <th class="cursor-pointer hover:bg-gray-50 transition-colors min-w-[120px] text-center" (click)="toggleSort('price')">
                <div class="flex items-center justify-center gap-2">
                  <span>Prix</span>
                  <span class="sort-icon text-xs" [ngClass]="sortField === 'price' ? (sortDirection === 'asc' ? 'asc' : 'desc') : ''">
                    <span *ngIf="sortField !== 'price'">↕</span>
                    <span *ngIf="sortField === 'price' && sortDirection === 'asc'">↓</span>
                    <span *ngIf="sortField === 'price' && sortDirection === 'desc'">↑</span>
                  </span>
                </div>
              </th>
              <th class="cursor-pointer hover:bg-gray-50 transition-colors min-w-[150px] text-center" (click)="toggleSort('availableToSell')">
                <div class="flex items-center justify-center gap-2">
                  <span>Dispo à la vente</span>
                  <span class="sort-icon text-xs" [ngClass]="sortField === 'availableToSell' ? (sortDirection === 'asc' ? 'asc' : 'desc') : ''">
                    <span *ngIf="sortField !== 'availableToSell'">↕</span>
                    <span *ngIf="sortField === 'availableToSell' && sortDirection === 'asc'">↓</span>
                    <span *ngIf="sortField === 'availableToSell' && sortDirection === 'desc'">↑</span>
                  </span>
                </div>
              </th>
            </tr>
          </thead>
          <tbody class="bg-white">
            <tr *ngFor="let s of paginatedServices" class="services-table-row" [class.bg-blue-50]="isServiceSelected(s._id)">
              <td class="services-table-cell text-center">
                <input
                  type="checkbox"
                  class="w-4 h-4 text-blue-600 border-gray-300 rounded focus:ring-blue-500 cursor-pointer"
                  [checked]="isServiceSelected(s._id)"
                  (change)="toggleServiceSelection(s._id)"
                />
              </td>
              <td class="services-table-cell text-center font-medium text-gray-800">
                {{ s.platform }}
              </td>
              <td class="services-table-cell text-center">
                {{ s.service }}
              </td>
              <td class="services-table-cell text-center">
                <span class="text-base font-semibold text-gray-800">
                  {{ formatNumber(s.totalFree) }}
                </span>
              </td>
              <td class="services-table-cell text-center">
                <span class="text-base font-semibold text-gray-800">
                  {{ formatNumber(s.price) }}
                </span>
              </td>
              <td class="services-table-cell text-center">
                <label class="inline-flex items-center cursor-pointer">
                  <input
                    type="checkbox"
                    class="w-4 h-4 text-blue-600 border-gray-300 rounded focus:ring-blue-500 cursor-pointer"
                    [checked]="s.availableToSell"
                    (change)="updateAvailableToSell(s)"
                  />
                  <span class="ml-2 text-base text-gray-700">
                    {{ s.availableToSell ? 'Oui' : 'Non' }}
                  </span>
                </label>
              </td>
            </tr>
            <tr *ngIf="filtered.length === 0" class="services-table-row">
              <td colspan="6" class="services-table-cell text-center text-gray-500 py-8">
                Aucun service trouvé
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="mt-6 flex justify-center">
        <app-pagination
          [currentPage]="currentPage"
          [totalPages]="totalPages"
          (pageChange)="onPageChange($event)">
        </app-pagination>
      </div>
    </div>
  </div>
</div>

<div class="services-modal-overlay" *ngIf="showBulkEditModal">
  <div class="services-modal-content" #bulkEditModalContent>
    <div class="services-modal-header">
      <div class="flex items-center gap-3">
        <div class="w-10 h-10 bg-blue-600 rounded-lg flex items-center justify-center">
          <span class="material-symbols-outlined text-white text-lg">edit</span>
        </div>
        <h2 class="text-lg font-semibold text-gray-900">Changer en masse ({{ selectedServices.size }} service{{ selectedServices.size > 1 ? 's' : '' }})</h2>
      </div>
      <button 
        class="w-8 h-8 flex items-center justify-center rounded-lg hover:bg-gray-100 active:bg-gray-200 transition-all duration-200 text-gray-400 hover:text-gray-600"
        (click)="closeBulkEditModal()" 
        type="button"
        [disabled]="isLoading">
        <span class="material-symbols-outlined text-lg">close</span>
      </button>
    </div>
    
    <div class="services-modal-body">
      <form (ngSubmit)="applyBulkChanges(); $event.preventDefault()" id="bulkEditForm">
        <div class="space-y-6">
          <div class="border-b border-gray-200 pb-4">
            <h3 class="text-sm font-semibold text-gray-900 mb-3">Disponible à la vente</h3>
            <div class="flex items-center gap-4">
              <label class="inline-flex items-center cursor-pointer">
                <input
                  type="radio"
                  name="bulkAvailableToSell"
                  [(ngModel)]="bulkAvailableToSell"
                  [value]="true"
                  class="w-4 h-4 text-blue-600 border-gray-300 focus:ring-blue-500 cursor-pointer"
                />
                <span class="ml-2 text-sm text-gray-700">Activer</span>
              </label>
              <label class="inline-flex items-center cursor-pointer">
                <input
                  type="radio"
                  name="bulkAvailableToSell"
                  [(ngModel)]="bulkAvailableToSell"
                  [value]="false"
                  class="w-4 h-4 text-blue-600 border-gray-300 focus:ring-blue-500 cursor-pointer"
                />
                <span class="ml-2 text-sm text-gray-700">Désactiver</span>
              </label>
              <label class="inline-flex items-center cursor-pointer">
                <input
                  type="radio"
                  name="bulkAvailableToSell"
                  [(ngModel)]="bulkAvailableToSell"
                  [value]="null"
                  class="w-4 h-4 text-blue-600 border-gray-300 focus:ring-blue-500 cursor-pointer"
                />
                <span class="ml-2 text-sm text-gray-700">Ne pas modifier</span>
              </label>
            </div>
          </div>

          <div class="border-b border-gray-200 pb-4">
            <h3 class="text-sm font-semibold text-gray-900 mb-3">Règles conditionnelles</h3>
            <div class="space-y-4">
              <div class="grid grid-cols-1 md:grid-cols-4 gap-2">
                <select
                  [(ngModel)]="ruleField1"
                  name="ruleField1"
                  class="px-3 py-2 text-sm border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 bg-white">
                  <option value="price">Prix</option>
                  <option value="totalFree">Total Free</option>
                </select>
                <select
                  [(ngModel)]="ruleOperator1"
                  name="ruleOperator1"
                  class="px-3 py-2 text-sm border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 bg-white">
                  <option value=">">></option>
                  <option value="<"><</option>
                  <option value=">=">>=</option>
                  <option value="<="><=</option>
                  <option value="==">==</option>
                </select>
                <input
                  type="number"
                  [(ngModel)]="ruleValue1"
                  name="ruleValue1"
                  placeholder="Valeur"
                  class="px-3 py-2 text-sm border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 bg-white"
                />
                <div class="flex items-center">
                  <select
                    [(ngModel)]="ruleLogic"
                    name="ruleLogic"
                    class="px-3 py-2 text-sm border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 bg-white">
                    <option value="AND">ET</option>
                    <option value="OR">OU</option>
                  </select>
                </div>
              </div>

              <div class="grid grid-cols-1 md:grid-cols-3 gap-2">
                <select
                  [(ngModel)]="ruleField2"
                  name="ruleField2"
                  class="px-3 py-2 text-sm border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 bg-white">
                  <option value="price">Prix</option>
                  <option value="totalFree">Total Free</option>
                </select>
                <select
                  [(ngModel)]="ruleOperator2"
                  name="ruleOperator2"
                  class="px-3 py-2 text-sm border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 bg-white">
                  <option value=">">></option>
                  <option value="<"><</option>
                  <option value=">=">>=</option>
                  <option value="<="><=</option>
                  <option value="==">==</option>
                </select>
                <input
                  type="number"
                  [(ngModel)]="ruleValue2"
                  name="ruleValue2"
                  placeholder="Valeur"
                  class="px-3 py-2 text-sm border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 bg-white"
                />
              </div>

              <div class="flex items-center gap-3">
                <span class="text-sm font-medium text-gray-700">Alors mettre disponible à :</span>
                <select
                  [(ngModel)]="ruleResult"
                  name="ruleResult"
                  class="px-3 py-2 text-sm border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 bg-white">
                  <option [value]="true">Oui</option>
                  <option [value]="false">Non</option>
                </select>
              </div>
            </div>
          </div>

          <div>
            <h3 class="text-sm font-semibold text-gray-900 mb-3">Services sélectionnés</h3>
            <div class="max-h-48 overflow-y-auto border border-gray-200 rounded-lg p-3 bg-gray-50">
              <div class="grid grid-cols-1 md:grid-cols-2 gap-2">
                <div *ngFor="let serviceId of selectedServicesArray" class="text-xs text-gray-600 py-1">
                  • {{ getServiceName(serviceId) }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
    
    <div class="services-modal-footer">
      <button 
        type="button" 
        class="services-btn-secondary"
        (click)="closeBulkEditModal()"
        [disabled]="isLoading">
        <span class="material-symbols-outlined text-base">close</span>
        <span>Annuler</span>
      </button>
      <button 
        type="submit" 
        class="services-btn-primary"
        form="bulkEditForm"
        [disabled]="isLoading">
        <span *ngIf="!isLoading" class="flex items-center gap-2">
          <span class="material-symbols-outlined text-base">save</span>
          <span>Appliquer</span>
        </span>
        <span *ngIf="isLoading" class="flex items-center gap-2">
          <div class="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
          <span>Application...</span>
        </span>
      </button>
    </div>
  </div>
</div>

